// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".entries-header[data-v-55842b1a]{display:flex;justify-content:space-between;align-items:center;margin-bottom:24px;margin-top:24px}.contactum_pagination[data-v-55842b1a]{float:right;background:#fff;border-radius:8px;box-shadow:0 1px 3px rgba(30,31,33,.08);display:inline-flex;font-weight:500;max-width:100%;padding:12px 20px;margin-top:20px}", ""]);
// Exports
module.exports = exports;
